// @flow

import React from 'react';
import { Segment, Form } from 'semantic-ui-react';
import QuestionHeader from './QuestionHeader';
import QuestionTypeSelector from './QuestionTypeSelector';
import QuestionContent from './QuestionContent';
import QuestionRequiredField from './QuestionRequiredField';
import { isQuestionValid } from '../../helpers';
import type { Question, QuestionType } from '../../types';

type Props = {
  question: Question,
  showValidationErrors: boolean,
  questionsCount: number,
  onUpdate: (question: Question) => void,
  onChangeOrder: (question: Question, order: number) => void,
  onChangeType: (question: Question, type: QuestionType) => void,
  onDelete: (question: Question) => void,
};

const styles = {
  segment: {
    margin: '1em',
  },
  divider: {
    height: '1em',
  },
};

class QuestionItem extends React.Component<Props> {
  props: Props;

  render() {
    const {
      question,
      showValidationErrors,
      questionsCount,
      onUpdate,
      onChangeOrder,
      onChangeType,
      onDelete,
    } = this.props;

    const isValid = isQuestionValid(question);

    const changeQuestion = (field: string) => (
      value: string | SyntheticEvent<*> | boolean
    ) =>
      onUpdate({
        ...question,
        [field]: value.target ? value.target.value : value,
      });

    const changeOrder = (order: number) => onChangeOrder(question, order);
    const changeType = (type: QuestionType) => onChangeType(question, type);

    const deleteQuestion = () => onDelete(question);

    return (
      <Segment style={styles.segment} color={isValid ? null : 'red'}>
        <Form>
          <QuestionHeader
            question={question}
            showValidationErrors={showValidationErrors}
            questionsCount={questionsCount}
            onChangeTitle={changeQuestion('title')}
            onChangeOrder={changeOrder}
            onDelete={deleteQuestion}
          />
          <div style={styles.divider} />
          <QuestionTypeSelector
            question={question}
            content={question.content}
            onChange={changeType}
          />
          <Form.Field
            required
            error={showValidationErrors && question.description.length === 0}
          >
            <label>Description détaillée</label>
            <input
              type="text"
              value={question.description}
              onChange={changeQuestion('description')}
              placeholder="Saisissez une description détaillée"
            />
          </Form.Field>
          <QuestionContent
            content={question.content}
            showValidationErrors={showValidationErrors}
            onChange={changeQuestion('content')}
          />
          <div style={styles.divider} />
          <QuestionRequiredField
            value={question.required}
            onChange={changeQuestion('required')}
          />
        </Form>
      </Segment>
    );
  }
}

export default QuestionItem;



// WEBPACK FOOTER //
// ./src/modules/survey/components/questions/QuestionItem.js